import BudgetServiceV3 from "@/services/BudgetServiceV3";

export default {
  data() {
    return {
      budgetServiceV3: new BudgetServiceV3(),
      pspsNumbers: [],
      loadingPspsNumbers: false,
    };
  },
  methods: {
    async getPspsNumbers(clientId, delayLoading = false, successCallback = null) {
      let loadingTimeout;
      if (delayLoading) {
        loadingTimeout = setTimeout(() => {
          this.loadingPspsNumbers = true;
        }, 300);
      } else {
        this.loadingPspsNumbers = true;
      }
      try {
        const response = await this.budgetServiceV3.getBudgetPSPSNumbers({
          clientId: clientId,
        });
        if (response?.result?.rows) {
          this.pspsNumbers = response.result.rows;
        } else {
          this.pspsNumbers = [];
        }
        if (successCallback) {
          successCallback(this.pspsNumbers);
        }
      } catch (e) {
        this.pspsNumbers = [];
        console.error("Failed to load PSPS numbers", e);
      } finally {
        clearTimeout(loadingTimeout);
        this.loadingPspsNumbers = false;
      }
    },
  },
};
